import { MedewerkersOpStation } from "@/entities/medewerkers-op-station";
import { DotVariants } from "@/shared/components";

export const statusMap: Record<
    Exclude<MedewerkersOpStation["status"], "NietAangevraagd">,
    { label: string; dotVariant: DotVariants["variant"] }
> = {
    AanvraagLoopt: { label: "VOS aanvraag loopt", dotVariant: "info" },
    VosIngezet: { label: "VOS ingezet", dotVariant: "succes" },
    GeenVosInzetbaar: { label: "Geen VOS inzetbaar", dotVariant: "neutral" },
    Gestopt: { label: "Gestopt", dotVariant: "neutral" },
} as const;
